import React, { useEffect, useState } from 'react'
import api from '../../services/api';
import { useParams } from 'react-router-dom';
import { Card, Typography } from '@mui/material';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Loading from '../../load/loading';
import DateHora from '../../utils/dateHora';

interface Solicitacao {
  numeroCertificado: string;
  resultado: string;
  certificadoEmitedAt: string;
  autorizacaoEmitedAt: string;
  relatorioEmitedAt: string;
  numero: string;
  certificadoEmited: boolean;
  autorizacaoEmited: boolean;
  relatorioEmited: boolean;
  producto: {
    nome: string;
    lote: string;
    fabricante: string;
  };
  analista: {
    dadosPessoais: {
      nome: string;
    }
  };
  solicitacaoAnalise: {
    nome: string;
  }
}

const ConsultorAnalitico = () => {
  const { tipo, id } = useParams();
  const [solicitacao, setSolicitacao] = useState<Solicitacao>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    api.get(`/avalicao-analitica/${id}`)
      .then((response) => {
        setSolicitacao(response.data.avaliacaoAnalitica);
      })
      .catch((err) => '')
      .finally(() => setLoading(false));
  }, [id, tipo])

  if (loading) {
    <Loading text='A VERIFICAR DOCUMENTO...' focus={''} />
  }

  const anoCertificado = solicitacao?.certificadoEmitedAt
    ? new Date(solicitacao.certificadoEmitedAt).getFullYear()
    : ""

  return (
    <div style={{ minHeight: '75vh' }}>
      {tipo === 'certificado'
        ? <>
          <Typography align='center'>
            <CheckCircleOutlineIcon
              color="success"
              className="text-[80px] mb-2" />
            <br />
            <b>Autenticidade de documentação</b>
            <br />
            <br />
          </Typography>

          {solicitacao?.certificadoEmited ? <Card style={{ padding: 20, maxWidth: 500, margin: 'auto' }}>
            <Typography variant="body2">Nº do Certificado: <b>{solicitacao?.numeroCertificado}/LNCQ/ARMED/{anoCertificado}</b></Typography>
            <Typography variant="body2">Tipo de documento: <b>Certificado</b></Typography>
            <Typography variant="body2">Nº de Lote: <b>{solicitacao?.producto.lote}</b></Typography>
            <Typography variant="body2">Resutado: <b>{solicitacao?.resultado}</b></Typography>
            <Typography variant="body2">Analista: <b>{solicitacao?.analista?.dadosPessoais?.nome}</b></Typography>
            <br />

            <Typography variant="body2">Este documento foi emitido pela - ARMED, em Luanda aos,   <b><DateHora date={solicitacao?.certificadoEmitedAt} /></b></Typography>
          </Card> :
            <div style={{ padding: 20 }}>
              <Typography style={{ lineHeight: 1 }} align="center" variant="subtitle1">
                Certificado não reconhecida pela ARMED
              </Typography>
            </div>}
        </>
        : tipo === 'relatorio'
          ? <>
            <Typography align='center'>
              <CheckCircleOutlineIcon
                color="success"
                className="text-[80px] mb-2" />
              <br />
              <b>Autenticidade de documentação</b>
              <br />
              <br />
            </Typography>

            {solicitacao?.relatorioEmited ? <Card style={{ padding: 20, maxWidth: 500, margin: 'auto' }}>
              <Typography variant="body2">Tipo de documento: <b>Relatório Análitico</b></Typography>
              <Typography variant="body2">Nome do produto: <b>{solicitacao?.producto.nome}</b></Typography>
              <Typography variant="body2">Nº de Lote: <b>{solicitacao?.producto.lote}</b></Typography>
              <Typography variant="body2">Resutado: <b>{solicitacao?.resultado}</b></Typography>
              <Typography variant="body2">Número de registro da amostra: <b>{solicitacao?.numero}</b></Typography>
              <br />

              <Typography variant="body2">Este documento foi emitido pela - ARMED, em Luanda aos,   <b><DateHora date={solicitacao?.autorizacaoEmitedAt} /></b></Typography>
            </Card> :
              <div style={{ padding: 20 }}>
                <Typography style={{ lineHeight: 1 }} align="center" variant="subtitle1">
                  Relatório Análitico não reconhecida pela ARMED
                </Typography>
              </div>}
          </>
          : <>
            <Typography align='center'>
              <CheckCircleOutlineIcon
                color="success"
                className="text-[80px] mb-2" />
              <br />
              <b>Autenticidade de documentação</b>
              <br />
              <br />
            </Typography>

            {solicitacao?.autorizacaoEmited ? <Card style={{ padding: 20, maxWidth: 500, margin: 'auto' }}>
              <Typography variant="body2">Tipo de documento: <b>Autorização</b></Typography>
              <Typography variant="body2">Nome do produto: <b>{solicitacao?.producto.nome}</b></Typography>
              <Typography variant="body2">Nº de lote: <b>{solicitacao?.producto.lote}</b></Typography>
              <Typography variant="body2">Resutado: <b>{solicitacao?.resultado}</b></Typography>
              <Typography variant="body2">Nome o remetente: <b>{solicitacao?.solicitacaoAnalise.nome}</b></Typography>
              <Typography variant="body2">Fabricante: <b>{solicitacao?.producto?.fabricante}</b></Typography>
              <br />

              <Typography variant="body2">Este documento foi emitido pela - ARMED, em Luanda aos,   <b><DateHora date={solicitacao?.relatorioEmitedAt} /></b></Typography>
            </Card> :
              <div style={{ padding: 20 }}>
                <Typography style={{ lineHeight: 1 }} align="center" variant="subtitle1">
                  Autorização não reconhecida pela ARMED
                </Typography>
              </div>}
          </>
      }

    </div>
  )
}

export default ConsultorAnalitico
